const addHidePropertiesToClassrooms = (hiddenContentData, classrooms) => {
  return classrooms.map((classroom) => {
    const hideId = hiddenContentData.find(
      (content) => content.classroom_id === classroom.id,
    )?.id;
    return {
      ...classroom,
      isContentHidden: !!hideId,
      hideId,
    };
  });
};

export default addHidePropertiesToClassrooms;
